module.exports = __webpack_public_path__ + "static/media/24-6.769a724e.mp3";